export default __webpack_public_path__ + "1bbd1c3d0c45ae068536bb0e2a81370e.png";